import React from 'react';

export type NavItem<T extends string> = {
  key: T;
  label: string;
  icon: string;
};

type ConfigNavProps<T extends string> = {
  items: NavItem<T>[];
  activeKey: T;
  onSelect: (key: T) => void;
  onUndo?: () => void;
  onRedo?: () => void;
  canUndo?: boolean;
  canRedo?: boolean;
};

export default function ConfigNav<T extends string>({
  items,
  activeKey,
  onSelect,
  onUndo,
  onRedo,
  canUndo = false,
  canRedo = false,
}: ConfigNavProps<T>) {
  return (
    <nav className="config-nav" aria-label="Navigation">
      {items.map(item => (
        <button
          key={item.key}
          className={`config-nav-btn ${activeKey === item.key ? 'is-active' : ''}`}
          type="button"
          onClick={() => onSelect(item.key)}
          data-tutorial={`nav-${item.key}`}
        >
          <span className="config-nav-icon">
            <img src={item.icon} alt="" aria-hidden="true" />
          </span>
          <span className="config-nav-label">{item.label}</span>
        </button>
      ))}
      <div className="config-nav-divider" />
      <div className="config-nav-actions">
        <button
          className={`config-nav-btn is-ghost ${!canUndo ? 'is-disabled' : ''}`}
          type="button"
          aria-label="Annuler"
          onClick={onUndo}
          disabled={!canUndo}
        >
          <span className="config-nav-icon">
            <img src="/assets/icon/icons8-undo-50.png" alt="" aria-hidden="true" />
          </span>
        </button>
        <button
          className={`config-nav-btn is-ghost ${!canRedo ? 'is-disabled' : ''}`}
          type="button"
          aria-label="Retablir"
          onClick={onRedo}
          disabled={!canRedo}
        >
          <span className="config-nav-icon">
            <img className="icon-mirror" src="/assets/icon/icons8-return-50.png" alt="" aria-hidden="true" />
          </span>
        </button>
      </div>
    </nav>
  );
}
